import React, { Component } from "react";

import {
  DKLabel,
  DKButton,
  DKInput,
  DKIcon,
  DKIcons,
  DKListPicker,
  showLoader,
  removeLoader,
  DKInputForm,
  INPUT_TYPE,
  showAlert,
  showToast,
  TOAST_TYPE,
  DKLine,
} from "deskera-ui-library";
import CampaignManager from "./CampaignManager";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import ApiManager from "../../managers/ApiManager";
import { CampaignService } from "../../services/campaign";
import CampaignPageHeader from "./CampaignPageHeader";
import AddSegmentPopup from "../common/AddSegmentPopup";
import Utility from "../../utility/Utility";
import SmtpPopup from "./SmtpPopup";
import DKDateTime from "../common/DKDateTime";
import SMTPService from "../../services/smtp";

class CampaignSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEdit: CampaignManager.isPageDataAvailable() ? true : false,
      needSegmentListPicker: false,
      segmentList: [],
      segmentOptionList: [],
      selectedSegment: "",
      needEmailForm: false,
      canValidate: false,
      formData: {
        subject: null,
        preHeaderText: "",
        from: null,
        segmentId: null,
        publish_on: new Date().toISOString(),
        send_now: true,
        smtp_setup_id: 0,
      },
      needAddSegmentPopup: false,
      needSMTPPopup: false,
      needDateTime: false,
      date: null,
      time: null,
      loader: false,
      smtpData: null,
      defaultSMTPSelected: true,
    };
  }

  componentDidMount() {
    RouteManager.setPresenter(this);
    if (!CampaignManager.isPageDataAvailable() && !this.props.match.params.id) {
      RouteManager.navigateToPage(PAGE_ROUTES.SELECT_CAMPAIGN_TEMPLATE);
      return;
    }

    if (!CampaignManager.isPageDataAvailable() && this.props.match.params.id) {
      CampaignManager.fetchPageDataById(this.props.match.params.id, () => {
        if (CampaignManager.getCampaignId()) {
          this.initialise();
        }
      });
    } else {
      this.initialise();
    }
    this.getAllSMTPData();
  }

  initialise() {
    this.setState({ isEdit: true }, () => {
      this.onEditData();
      this.getSegmentList();
      this.getDateTimeShow();
    });
  }

  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  getAllSMTPData() {
    SMTPService.getSetups().then((response) => {
      if (response && response.data && response.data.length > 0) {
        this.setSMTPData(response.data[0]);
      }
    });
  }

  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  render() {
    return (
      <div className="column parent-width  ">
        <CampaignPageHeader
          title={"Template Summary"}
          stepperIndex={2}
          onSave={this.campaignPublish}
        />
        <div
          className="column p-l bg-white border-radius-s parent-width border-box mt-xl align-self-center shadow-s align-items-center"
          style={{ maxWidth: 800, marginBottom: 100 }}
        >
          <DKLabel text="Template Summary" className="fw-m fs-xl mt-l" />
          <DKLabel
            text="View a summary of your template and active it for your contact list"
            className="text-gray fs-m mt-s text-align-center"
          />
          {this.state.loader && this.getForm()}
          {!CampaignManager.checkCampaignSent() && (
            <div className="row justify-content-center mt-l mb-l">
              <DKButton
                title="Send a test email"
                className="bg-gray2 border-m "
                onClick={() => {
                  this.setState({ needEmailForm: true });
                }}
              />
              <DKButton
                title="Activate & Send"
                className="bg-app text-white ml-m"
                onClick={() => {
                  this.campaignPublish();
                }}
              />
            </div>
          )}
          {CampaignManager.checkCampaignSent() && (
            <div className="row justify-content-center mt-xxl mb-l">
              <DKButton
                title="Next"
                className="bg-app text-white ml-m"
                onClick={() => {
                  const pageId = CampaignManager.getCampaignId()
                    ? "/" + CampaignManager.getCampaignId()
                    : "";
                  RouteManager.navigateToPage(
                    PAGE_ROUTES.CAMPAIGN_SUCCESS + pageId
                  );
                }}
              />
            </div>
          )}
        </div>
        {this.state.needEmailForm && this.getEmailForm()}
        {this.state.needAddSegmentPopup && this.getAddSegmentPopup()}
        {this.state.needSMTPPopup && this.getSMTPPopup()}
        {this.state.needDateTime && this.getDateTimePicker()}
      </div>
    );
  }

  getForm() {
    return (
      <div className="parent-width mt-xxl mb-m" style={{ maxWidth: 450 }}>
        <DKInput
          title="Subject"
          type={INPUT_TYPE.TEXT}
          value={this.state.formData.subject}
          required
          canValidate={this.state.canValidate}
          onChange={(value) => this.saveFormData("subject", value)}
          readOnly={CampaignManager.checkCampaignSent()}
        />
        {/* <DKInput
          title="Preheader Text"
          type={INPUT_TYPE.TEXT}
          value={this.state.formData.preHeaderText}
          canValidate={this.state.canValidate}
          required
          className="mt-m"
          onChange={(value) => this.saveFormData("preHeaderText", value)}
          readOnly={CampaignManager.checkCampaignSent()}
        /> */}
        {this.state.defaultSMTPSelected && (
          <DKInput
            title="Sender Email"
            type={INPUT_TYPE.EMAIL}
            required
            className="mt-m"
            value={this.state.formData.from}
            canValidate={this.state.canValidate}
            onChange={(value) => this.saveFormData("from", value)}
            readOnly={CampaignManager.checkCampaignSent()}
          />
        )}
        {this.getSegmentSection()}

        <DKLabel text="Schedule a Template" className=" mt-xxl fw-m mb-r" />
        <div className="p-s border-orange border-radius-s bg-deskera-secondary row justify-content-between">
          <div className="row " style={{ width: "auto" }}>
            <div className="position-relative row" style={{ width: "auto" }}>
              <DKIcon src={DKIcons.ic_calendar} className="ic-s mr-r" />
              <DKLabel text={`${this.state.date}, `} />
            </div>
            <div className="position-relative row" style={{ width: "auto" }}>
              <DKLabel
                text={`${
                  this.state.formData.send_now ? "(Send now)" : this.state.time
                }`}
              />
            </div>
          </div>
          {!CampaignManager.checkCampaignSent() && (
            <DKButton
              // icon={DKIcons.ic_edit}
              title="Change"
              className="bg-orange text-white"
              onClick={() => this.showDateTimePopup()}
            />
          )}
        </div>
        {this.getSMTPSection()}
      </div>
    );
  }

  saveFormData = (key, value) => {
    let formData = this.state.formData;
    formData[key] = value;
    this.setState({ formData });
  };

  ///////////////////////////////////////////////////

  campaignPublish = () => {
    this.setState({ canValidate: true });
    if (!this.state.defaultSMTPSelected) {
      let formData = this.state.formData;
      formData.from = this.state.smtpData.username;
      this.setState({ formData: formData });
    }

    if (
      Utility.isEmpty(this.state.formData.from) ||
      Utility.isEmpty(this.state.formData.subject) ||
      // Utility.isEmpty(this.state.formData.preHeaderText) ||
      Utility.isEmpty(this.state.formData.publish_on) ||
      Utility.isEmpty(this.state.formData.segmentId)
    ) {
      return;
    }

    if (!Utility.isValidEmail(this.state.formData.from)) {
      return;
    }

    const tableId = CampaignManager.getTableId();
    const recordId = CampaignManager.getCampaignId();
    let requestData = CampaignManager.getRequestToPublishPage(
      this.state.formData
    );
    if (requestData !== {}) {
      showLoader("Activate campaign...");
      CampaignService.update(requestData, tableId, recordId)
        .then((data) => {
          const pageId = CampaignManager.getCampaignId()
            ? "/" + CampaignManager.getCampaignId()
            : "";
          CampaignManager.setPageData(data);
          CampaignManager.setCampaignStatus(CampaignManager.status.SENT);
          RouteManager.navigateToPage(PAGE_ROUTES.CAMPAIGN_SUCCESS + pageId);
          removeLoader();
        })
        .catch((err) => {
          removeLoader();
        });
    }
  };
  showDateTimePopup = () => {
    this.setState({ needDateTime: true });
  };

  hideDateTimePopup = () => {
    this.setState({ needDateTime: false });
  };

  getDateTimePicker = () => {
    return (
      <div className="transparent-background">
        <div className="popup-window">
          <DKLabel text="🎯 Schedule a Template" className="fw-m fs-m mb-m" />
          <DKLine className="mb-m" />
          <DKDateTime
            is12Hour={true}
            selectedDate={this.state.formData.publish_on}
            onSave={(date) => {
              this.publishDateUpdate(date);
            }}
            onClose={() => {
              this.hideDateTimePopup();
            }}
          />
        </div>
      </div>
    );
  };

  saveSegment = (value) => {
    let segmentId = this.state.segmentOptionList.find(
      (list) => list.name === value
    );
    this.saveFormData("segmentId", [segmentId.id]);
    this.setState({ selectedSegment: value });
  };

  getSegmentSection() {
    return (
      <div className="row justify-content-between align-items-start parent-width mt-s">
        <DKLabel text="Target Audience *" className="mt-l" />
        <div
          className="row justify-content-between p-h-r p-v-s border-m bg-gray1 border-radius-s mt-r position-relative cursor-hand"
          style={{ width: 300 }}
        >
          <div
            className="position-absolute parent-width parent-height "
            style={{ top: 0, left: 0 }}
            onClick={this.showSegmentListPicker}
          />
          <DKLabel className="unselectable" text={this.state.selectedSegment} />
          {!CampaignManager.checkCampaignSent() && (
            <DKIcon
              src={DKIcons.ic_arrow_down2}
              className="ic-s unselectable"
            />
          )}
          {this.state.needSegmentListPicker &&
            !CampaignManager.checkCampaignSent() &&
            this.getSegmentListPicker()}
        </div>
      </div>
    );
  }

  getSegmentListPicker() {
    return (
      <DKListPicker
        data={this.state.segmentList}
        className="position-absolute border-m shadow-m parent-width z-index-1"
        style={{ top: 36, left: 0 }}
        onSelect={(index, value) => {
          this.saveSegment(value);
          this.hideSegmentListPicker();
        }}
        onClose={this.hideSegmentListPicker}
        // button={{
        //   title: "+ Add segment",
        //   className: "bg-app text-white",
        //   onClick: () => {
        //     this.showAddSegmentPopup();
        //   },
        // }}
      />
    );
  }

  showSegmentListPicker = () => {
    if (!this.state.needSegmentListPicker) {
      this.setState({ needSegmentListPicker: true });
    }
  };
  hideSegmentListPicker = () => {
    setTimeout(() => {
      this.setState({ needSegmentListPicker: false });
    }, 10);
  };

  getSegmentList() {
    showLoader("Fetching Segment List...");
    let segmentColum = TableManger.getColumn(
      TABLES.CONTACT,
      COLUMN_CODE.CONTACT.SEGMENT
    );
    this.setSegment(segmentColum);
  }

  setSegment = (segmentColum) => {
    let segmentName = "";
    this.filterColumnId = segmentColum.key;
    let segmentOption = segmentColum.options.map((value) => {
      return value.name;
    });
    if (this.state.isEdit && this.state.formData.segmentId) {
      let segment = segmentColum.options.find(
        (list) => list.id === this.state.formData.segmentId[0]
      );
      segmentName = segment.name;
    } else {
      segmentName = segmentOption[0];
    }
    this.setState(
      {
        segmentList: segmentOption,
        segmentOptionList: segmentColum.options,
        selectedSegment: segmentName,
      },
      () => {
        removeLoader();
        this.saveSegment(segmentName);
      }
    );
  };

  hideEmailForm = () => {
    this.setState({
      needEmailForm: false,
    });
  };
  getEmailForm() {
    let formData = [
      {
        key: "email",
        icon: DKIcons.ic_email,
        title: "To",
        type: INPUT_TYPE.EMAIL,
        value: "",
      },
      {
        key: "subject",
        icon: DKIcons.ic_text,
        title: "Subject",
        type: INPUT_TYPE.TEXT,
        value: "",
      },
    ];
    return (
      <div className="transparent-background">
        <DKInputForm
          title="E-Mail campaign"
          className="popup-window "
          fields={formData}
          onSubmit={(data) => {
            let templateData = CampaignManager.getTemplateHTMLData();
            if (templateData == null) {
              showAlert("Error!", "Please select template");
              return;
            }
            ApiManager.sendEmail(
              data[1].value,
              data[0].value,
              templateData,
              () => {
                this.hideEmailForm();
              }
            );
          }}
          onCancel={this.hideEmailForm}
        />
      </div>
    );
  }

  onEditData = () => {
    if (!this.state.isEdit) {
      return;
    }
    const campaignData = CampaignManager.getPageData();
    let formData = this.state.formData;
    formData.subject =
      campaignData.data.cells[
        CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.EMAIL_SUBJECT)
      ];
    formData.preHeaderText =
      campaignData.data.cells[
        CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.EMAIL_PRE_HEADER)
      ];
    formData.from =
      campaignData.data.cells[
        CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.EMAIL_FROM)
      ];
    formData.segmentId =
      campaignData.data.cells[
        CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.SEGMENT_ID)
      ];
    formData.publish_on =
      campaignData.data.cells[
        CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.PUBLISHED_ON)
      ];
    let send_now =
      campaignData.data.cells[
        CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.SEND_NOW)
      ];
    formData.send_now = send_now !== undefined ? send_now : true;
    formData.smtp_setup_id =
      campaignData.data.cells[
        CampaignManager.getColumnId(COLUMN_CODE.CAMPAIGN.SMTP_SETUP_ID)
      ];
    this.setState({
      formData: formData,
      loader: true,
      defaultSMTPSelected:
        formData.smtp_setup_id === 0 || formData.smtp_setup_id === undefined
          ? true
          : false,
    });
  };

  getAddSegmentPopup() {
    return (
      <AddSegmentPopup
        onCancel={this.hideAddSegmentPopup}
        onSave={(columnData, segment) => {
          this.setSegment(columnData);
          this.saveSegment(segment.name);
          this.hideAddSegmentPopup();
        }}
      />
    );
  }

  showAddSegmentPopup = () => {
    this.setState({ needAddSegmentPopup: true });
  };

  hideAddSegmentPopup = () => {
    this.setState({ needAddSegmentPopup: false });
  };

  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  getSMTPPopup() {
    return (
      <SmtpPopup
        data={this.state.smtpData}
        onCancel={this.hideSMTPPopup}
        onSave={(smtpData) => {
          this.hideSMTPPopup();
          this.setSMTPData(smtpData);
          this.saveFormData("smtp_setup_id", smtpData.id);
          this.setState({ defaultSMTPSelected: false });
        }}
      />
    );
  }
  hideSMTPPopup = () => {
    this.setState({ needSMTPPopup: false });
  };
  showSMTPPopup = () => {
    this.setState({ needSMTPPopup: true });
  };
  setSMTPData = (data) => {
    if (data === null || data === undefined) {
      this.setState({ defaultSMTPSelected: true });
      return;
    }

    this.setState({ smtpData: data }, () => {
      this.setState({
        defaultSMTPSelected: this.state.formData.smtp_setup_id === 0,
      });
    });
  };
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  getSMTPSection() {
    return (
      <div className="mt-xxl">
        <DKLabel text="Email Service (SMTP)" className="fw-m" />
        {this.getSMTPServerSelection()}
        {this.state.smtpData &&
          !this.state.defaultSMTPSelected &&
          this.getAddedSMTPDetails()}
      </div>
    );
  }
  getAddedSMTPDetails() {
    return (
      <div className="p-s mt-s border-orange border-radius-s bg-deskera-secondary row justify-content-between">
        <div className="row cursor-hand" style={{ width: "auto" }}>
          <div
            className="position-relative align-items-start row"
            style={{ width: "auto" }}
          >
            <DKIcon src={DKIcons.ic_email} className="ic-s mr-r" />
            <div className="column">
              <DKLabel className="fs-m fw-m" text={this.state.smtpData.name} />
              <DKLabel className="mt-xs" text={this.state.smtpData.email} />
            </div>
          </div>
        </div>
        {!CampaignManager.checkCampaignSent() && (
          <DKButton
            icon={DKIcons.ic_edit}
            title="Edit"
            className=""
            onClick={() => this.showSMTPPopup()}
          />
        )}
      </div>
    );
  }
  getSMTPServerSelection() {
    return (
      <div className="row flex-wrap mt-m mb-l">
        <label>
          <input
            type="radio"
            checked={this.state.defaultSMTPSelected}
            onChange={(e) => {
              if (CampaignManager.checkCampaignSent()) {
                return;
              }
              this.setState({ defaultSMTPSelected: true });
              this.saveFormData("smtp_setup_id", 0);
            }}
          />
          <DKLabel
            className="fs-m pl-xs pr-l"
            text={"Deskera email (default)"}
          />
        </label>
        <label>
          <input
            type="radio"
            checked={
              this.state.smtpData !== null && !this.state.defaultSMTPSelected
            }
            onChange={(e) => {
              if (CampaignManager.checkCampaignSent()) {
                return;
              }
              if (this.state.smtpData) {
                this.setState({ defaultSMTPSelected: false });
                this.saveFormData("smtp_setup_id", this.state.smtpData.id);
              } else {
                this.showSMTPPopup();
              }
            }}
          />
          <DKLabel className="fs-m pl-xs pr-l" text={"Use my own"} />
        </label>
      </div>
    );
  }

  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  getDateTimeShow = () => {
    let date = this.state.formData.publish_on
      ? new Date(this.state.formData.publish_on)
      : new Date();
    this.setState({ date: date.toDateString(), time: this.formatAMPM(date) });
    if (!this.state.formData.publish_on) {
      this.saveFormData("publish_on", new Date().toISOString());
    }
  };

  formatAMPM = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? (hours < 10 ? "0" + hours : hours) : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
  };

  publishDateUpdate = (date) => {
    var dateNew = Math.round(new Date(date).getTime() / 1000);
    let todayDate = Math.round(new Date().getTime() / 1000);
    if (todayDate > dateNew) {
      showToast("Please do not select past date", TOAST_TYPE.FAILURE);
      return;
    }
    this.saveFormData("publish_on", date);
    this.saveFormData("send_now", false);
    this.getDateTimeShow();
    this.hideDateTimePopup();
  };
}

export default CampaignSummary;
